import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography, notification } from "antd";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { orderList } from "../../../controllers/V1/cms/campaignController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import { formatProjectDate } from "../../../controllers/common";
import moment from "moment";
import { usePermissions } from "../../../controllers/PermissionContext";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import {list as generalData} from "../../../controllers/V1/cms/generalDataController";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const PERMISSION = usePermissions("campaignOrder");
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD') || '');
  const [todayTime, setTodayTime] = useState('00:00:00');
  const [yesterdayDate, setYesterdayDate] = useState(`${moment().subtract(1,'days').format('YYYY-MM-DD')}`);
  const [yesterdayTime, setYesterdayTime] = useState('00:01:00');

  const handleDateTimeChange = (e)=>{
    const {name, value} = e.target;
    if(name === 'valid_date'){
      setYesterdayDate(value)
    } else if(name === 'valid_time'){
      setYesterdayTime(value)
    } else if(name === 'expire_date'){
      setTodayDate(value)
    } else if(name === 'expire_time'){
      setTodayTime(value)
    }
  }

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    setError(null); // Reset the error state before each request
  
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);
  
      const baseCondition = {
        ...(formData.get("order_no") && { order_no: formData.get("order_no") }),
        ...(formData.get("campaign_title") && {
          campaign_title: {
            $regex: formData.get("campaign_title"),
            $options: "i",
          },
        }),
        ...(formData.get("seller_first_name") && {
          seller_first_name: {
            $regex: formData.get("seller_first_name"),
            $options: "i",
          },
        }),
        ...(formData.get("seller_last_name") && {
          seller_last_name: {
            $regex: formData.get("seller_last_name"),
            $options: "i",
          },
        }),
        ...(formData.get("seller_mobile") && {
          seller_mobile: parseInt(formData.get("seller_mobile")),
        }),
        ...(formData.get("seller_pos_number") && {
          seller_pos_number: parseInt(formData.get("seller_pos_number")),
        }),
        ...(formData.get("status") && { status: formData.get("status") }),
  
        createdAt: {
          $gte: `${yesterdayDate} ${yesterdayTime}`,
          $lte: `${todayDate} ${todayTime}`,
        },
      };
  
      const option = {
        isExport: true,
        condition: baseCondition,
        sort: { createdAt: -1 },
        skip: 0,
        limit: 5000, // Adjust this limit based on API performance
      };
  
      let allResults = [];
      let hasMore = true;
  
      while (hasMore) {
        const res = await orderList(option);
        if (res?.status === true && res?.result?.length > 0) {
          allResults = [...allResults, ...res.result];
          option.skip += option.limit;
  
          // Stop if fewer results than limit returned
          if (res.result.length < option.limit) {
            hasMore = false;
          }
        } else {
          hasMore = false;
        }
      }
  
      if (allResults.length > 0) {
        if (
          formData.get("exportType") === "Draw" &&
          (PERMISSION?.fullAccess === "Y" || PERMISSION?.exportType === "Y")
        ) {
          exportDrawData(allResults);
        } else {
          exportAccountData(allResults);
        }
        handleCancel();
      } else {
        setIsLoading(false);
        notification.open({
          message: "Oops!",
          description: `No records found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `An error occurred while exporting the data.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  };
  

  const exportDrawData = async (result) =>{
    try {
      let i = 0;
      const transformedData = await Promise.all(result.map((item) => {
          const ticket = item?.ticket;
          if (Array.isArray(ticket)) {
            return ticket.map((value) => {
              try {
                return {
                    "Sl.No." : ++i,
                    "POS No." : item.seller_pos_number,
                    "Order ID" : item.order_no,
                    "Product Name" : item?.campaign_title,
                    "Store Name" : item?.seller_user_id?.store_name,
                    "Seller Name" : item.seller_area || 'N/A',
                    "Seller Mobile" : item.seller_mobile,
                    "Bind With" : item.bind_person_name,
                    ...(value?.type === 'Straight' ? {"Straight Amount" : "1"}:{"Straight Amount" : "0"}),
                    ...(value?.type === 'Rumble' ? {"Rumble Amount" : "1"}:{"Rumble Amount" : "0"}),
                    ...(value?.type === 'Chance' ? {"Chance Amount" : "1"}:{"Chance Amount" : "0"}),
                    "Payment Status" :  item.status,
                    "Purchase Date" : moment(formatProjectDate(item.createdAt)).format('YYYY-MM-DD HH:mm'),
                    ...((PERMISSION.fullAccess === 'Y' || PERMISSION.coupon === 'Y') && {"Coupon Code" : value?.ticket}),

                };
              } catch (error) {
                return [];
              }
            });
          } else{
            try {
              return {
                  "Sl.No." : ++i,
                  "POS No." : item.seller_pos_number,
                  "Order ID" : item.order_no,
                  "Product Name" : item?.campaign_title,
                  "Store Name" : item?.seller_user_id?.store_name,
                  "Seller Name" : item.seller_area || 'N/A',
                  "Seller Mobile" : item.seller_mobile,
                  "Bind With" : item.bind_person_name,
                  "Straight Amount" : "0",
                  "Rumble Amount" : "0",
                  "Chance Amount" : "0",
                  "Payment Status" :  item.status,
                  "Coupon Code" : '',
                  "Purchase Date" : moment(formatProjectDate(item.createdAt)).format('YYYY-MM-DD HH:mm'),
              };
            } catch (error) {
              return [];
            }
          } 
        }));
        await exportToExcel(transformedData.flat()); 
    } catch (error) {
      
    }
  }

  const exportAccountData = async (result) => {
    try {
      let i = 0;
      const transformedData = await Promise.all(result.map((item) => {
        return {
          "Sl.No." : ++i,
          "POS No." : item.seller_pos_number,
          "Order ID" : item.order_no,
          "Product Name" : item?.campaign_title,
          "Store Name" : item?.seller_user_id?.store_name,
          "Seller Name" : item.seller_area || 'N/A',
          "Seller Mobile" : item.seller_mobile,
          "Bind With" : item.bind_person_name,
          "Payment Status" :  item.status,
          "Qty" : item.total_qty,
          "Points" : item.total_points,
          "Purchase Date" : moment(formatProjectDate(item.createdAt)).format('YYYY-MM-DD HH:mm'),
      };
      }));
      await exportToExcel(transformedData.flat()); 
    } catch (error) {
      
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Lotto-Orders");
      XLSX.writeFile(workbook, `Campaign Order ${moment().format('DD-MM-YYYY')}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getGeneralData = async () => {
    try {
      const option ={}
      const res = await generalData(option);
      if(res?.status === true){
        const time = moment().endOf('day').format('HH:mm:ss');
        const startTime = res?.result?.invoice_start_time;
        const endTime = res?.result?.invoice_end_time;
        setTodayTime(startTime || time);
        setYesterdayTime(endTime || time);
      }
    } catch (error) {
      
    }
  }

  useEffect(()=>{
    getGeneralData();
  },[])

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            className="inventory_popup_title_heading"
          >
            Export Campaign Order
          </Typography>
          <Link
            to={false}
            style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }}
            onClick={handleCancel}
          >
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <Typography
          variant="body1"
          component="div"
          className="my_delete_popup_paragraph"
        >
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="order_no"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Order No. :
                    </label>
                    <input
                      type="text"
                      name="order_no"
                      id="order_no"
                      placeholder="Order No."
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="campaign_title"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Campaign Title :
                    </label>
                    <input
                      type="text"
                      name="campaign_title"
                      id="campaign_title"
                      placeholder="Campaign Title"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_first_name"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Seller's first name :
                    </label>
                    <input
                      type="text"
                      name="seller_first_name"
                      id="seller_first_name"
                      placeholder="Seller's first name"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_last_name"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Seller's last name :
                    </label>
                    <input
                      type="text"
                      name="seller_last_name"
                      id="seller_last_name"
                      placeholder="seller Last Name"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_mobile"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Seller's mobile :
                    </label>
                    <input
                      type="text"
                      name="seller_mobile"
                      id="seller_mobile"
                      placeholder="Seller Mobile"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_pos_number"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Seller's POS No. :
                    </label>
                    <input
                      type="text"
                      name="seller_pos_number"
                      id="seller_pos_number"
                      placeholder="Seller's POS No"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_pos_number"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Status :
                    </label>
                    <select name="status" id="status" className="form-control categories_select_tg_enter_product">
                      <option value={'Success'} selected>Success</option>
                      <option value={'Cancel'} >Cancel</option>
                      <option value='' >All</option>
                    </select>
                   
                  </div>
                  {(PERMISSION?.fullAccess ==='Y' || PERMISSION?.exportType === 'Y') && (
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label
                        htmlFor="exportType"
                        className="all_lable_for_vendor_dashbaord"
                      >
                        Export Type :
                      </label>
                      <select name="exportType" id="exportType" className="form-control categories_select_tg_enter_product">
                        <option value={'Draw'} selected>Draw</option>
                        <option value={'Account'} >Account</option>
                      </select>
                    
                    </div>
                  )}

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label
                      for="select_title"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      {" "}
                      Date specific (If any) :
                    </label>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      From :
                    </label>
                    <input
                      type="date"
                      name="valid_date"
                      id="valid_date"
                      value={yesterdayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="valid_time"
                      id="valid_time"
                      value={yesterdayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      To :
                    </label>
                    <input
                      type="date"
                      name="expire_date"
                      id="expire_date"
                      value={todayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="expire_time"
                      id="expire_time"
                      value={todayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>


                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button
                        type="button"
                        className="btn btn-light categories_cancel_button"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-danger"
                        disabled={isLoading}
                      >
                        Download Excel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: "red" }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
